module.exports = __webpack_public_path__ + "img/Weak Signal Icon 2.e4767fd5.png";